import React from 'react'

export const ItemContent = ({ link }) => {
  return (
    <>
      {link.render ? link.render() : link.text}
    </>
  )
}
